import { render, staticRenderFns } from "./LxDatepicker2.vue?vue&type=template&id=38b3e027&scoped=true"
import script from "./LxDatepicker2.vue?vue&type=script&lang=js"
export * from "./LxDatepicker2.vue?vue&type=script&lang=js"
import style0 from "./LxDatepicker2.vue?vue&type=style&index=0&id=38b3e027&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b3e027",
  null
  
)

export default component.exports